import { render, staticRenderFns } from "./JSONBlock.vue?vue&type=template&id=d46598b6"
import script from "./JSONBlock.vue?vue&type=script&lang=ts"
export * from "./JSONBlock.vue?vue&type=script&lang=ts"
import style0 from "./JSONBlock.vue?vue&type=style&index=0&id=d46598b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports